import { render, staticRenderFns } from "./OrdemServico.vue?vue&type=template&id=55a62674&scoped=true"
import script from "./OrdemServico.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemServico.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a62674",
  null
  
)

export default component.exports